import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right-24-px_f818b9ea2319bed86e6121133040c9aa",
  "use": "arrow-right-24-px_f818b9ea2319bed86e6121133040c9aa-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-right-24-px_f818b9ea2319bed86e6121133040c9aa\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9.39309 18.5L8 17.1295L13.2138 12L8 6.87054L9.39309 5.5L16 12L9.39309 18.5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol